/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Link } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import Axios from 'axios';

// project imports
import { getBuyersUrl, getBuyerHeaders } from 'shared/http';

// style imports
import './VerifyEmail.scss';

/**
 * this page is used to verify new email
 * 
 * @param token
 * 
 * @returns html code to display invalid or expired token message
 * 
**/

export class VerifyEmail extends Component {

    constructor(props) {
        super(props);

        this.state = {
            pageLoading: true,
            emailMessage: '',
            messageColor: true
        };
    }

    componentDidMount() {
        this.validateToken();
        this.removeLoader();
    }

    removeLoader = () => {
        const loader = document.querySelector('.pre-loader');
        const root = document.querySelector('.ct-bids');
        loader.classList.add('hide-loader');
        root.classList.add('loaded');
    }

    /* checks whether the token is valid */
    validateToken = async () => {
        const token = this.props.location.search;
        if (token.includes('?token=')) {
            this.setState({
                token: token.replace('?token=', '')
            });

            await Axios.get(getBuyersUrl(`/api/v1/buyer/user/email/change/verify/${token.replace('?token=', '')}`), getBuyerHeaders(false))
                .then(response => {
                    this.setState({ 
                        pageLoading: false,
                        emailMessage: response.data.message,
                        messageColor: true
                    }, () => {
                        setTimeout(() => {
                            this.props.history.push('/');
                        }, 5000)
                    });    
                })
                .catch(error => {
                    this.setState({ 
                        pageLoading: false,
                        emailMessage: error.response.data.message,
                        messageColor: false
                     }, () => {
                        setTimeout(() => {
                            this.props.history.push('/');
                        }, 5000)
                     });        
                });
        } else {
            this.props.history.push('/not-found');
        }
    };

    render() {
        return (
            <div className="d-flex flex-column justify-content-center align-items-center email-verify">
                {
                    (this.state.emailMessage && !this.state.pageLoading) ?
                        <div className={`d-flex align-items-center justify-content-center ${this.state.messageColor ? 'green-text' : 'red-text'}`}>
                            <img src={`${this.state.messageColor ? `${process.env.PUBLIC_URL}/static/images/tick-green.png` : `${process.env.PUBLIC_URL}/static/images/cross-red.png`}`} />{this.state.emailMessage}
                        </div> :
                        this.state.pageLoading ?
                            <Spinner animation="border" variant="info" className="spinner-3x" /> :
                            <div className="d-flex flex-column bg-white p-4 email-verify-card">
                                <div className="d-flex flex-row justify-content-center mb-4">
                                    <img src={`${process.env.PUBLIC_URL}/static/logo/Seller_logo_signup.svg`} alt="logo" height="50px" width="170px" />
                                </div>

                                <div className="d-flex flex-row mt-5">
                                    <h5 className="text-secondary"><b>Email Verify</b></h5>
                                </div>
                                <div className="d-flex flex-column my-5">
                                    <p>The link you provided to verify email is either invalid or expired.</p>
                                    <div className="d-flex flex-row justify-content-end">
                                        <Link to="/">
                                            <small className="text-secondary">Back To Sign In</small>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                }
            </div>
        );
    }
}